export default "__VITE_ASSET__B2GqMMCr__"